export enum Cultures {
  SA = 'ar-SA',
  DE = 'de-DE',
  US = 'en-US',
  ES = 'es-ES',
  FR = 'fr-FR',
  IT = 'it-IT',
  JP = 'ja-JP',
  KR = 'ko-KR',
  NL = 'nl-NL',
  PL = 'pl-PL',
  BR = 'pt-BR',
  RU = 'ru-RU',
  SE = 'sv-SE',
  TR = 'tr-TR',
  UA = 'uk-UA',
  CN = 'zh-CN',
}
